import React, { useEffect } from "react";

const CoverPromptBox = ({ coverPrompt, setCoverPrompt, ordersData }) => {
  useEffect(() => {
    if (typeof ordersData !== "undefined") {
      setCoverPrompt(ordersData["prompts"]["cover_prompt"]);
    } else {
      fetch("/book_cover_template.txt")
        .then((response) => response.text())
        .then((data) => setCoverPrompt(data))
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);

  const handleChange = (e) => {
    setCoverPrompt(e.target.value);
  };

  return (
    <div className="mt-10 shadow-lg bg-gray-100 rounded-lg pl-6 pb-3 pt-2">
      <div className="text-center font-bold pb-2">Cover Prompt Box</div>
      <textarea
        type="text"
        id="cover-prompt-box"
        value={coverPrompt}
        onChange={handleChange}
        placeholder="Enter cover prompt..."
        style={{
          width: "600px",
          height: "200px",
          border: "1px solid black",
          borderRadius: "10px",
          padding: "5px",
        }}
      />
    </div>
  );
};

export default CoverPromptBox;
